// ═══════════════════════════════════════════════════════════════════
//  modules/projets/ProjectsList.js
//  ProjectsList
// ═══════════════════════════════════════════════════════════════════

import { useCallback, useEffect, useState } from "react";
import { Badge } from "../../composants/Badge";
import { API_BASE } from "../../socle/api";
import { THEME } from "../../socle/theme";
import { ProjectView } from "./ProjectView";

export function ProjectsList({ token, currentUserId }) {
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [showNewProject, setShowNewProject] = useState(false);
  const [newName, setNewName] = useState("");
  const [newDesc, setNewDesc] = useState("");

  const loadProjects = useCallback(async () => {
    const res = await fetch(`${API_BASE}/api/projects`, { headers: { Authorization: `Bearer ${token}` } });
    const data = await res.json();
    setProjects(Array.isArray(data) ? data : []);
  }, [token]);

  useEffect(() => { loadProjects(); }, [loadProjects]);

  const createProject = async () => {
    if (!newName.trim()) return;
    await fetch(`${API_BASE}/api/projects`, {
      method: "POST", headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      body: JSON.stringify({ name: newName, description: newDesc }),
    });
    setNewName(""); setNewDesc(""); setShowNewProject(false); loadProjects();
  };

  if (selectedProject) return <ProjectView token={token} projectId={selectedProject} currentUserId={currentUserId} onBack={() => { setSelectedProject(null); loadProjects(); }} />;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h2 style={{ color: THEME.text, fontSize: 18, fontWeight: 700, margin: 0 }}>📋 Projets</h2>
        <button onClick={() => setShowNewProject(true)} style={{ background: THEME.accentDim, border: `1px solid ${THEME.accent}`, color: THEME.accent, borderRadius: 8, padding: "8px 16px", cursor: "pointer", fontSize: 13, fontWeight: 700 }}>+ Nouveau projet</button>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: 14 }}>
        {projects.map((p) => (
          <div key={p.id} onClick={() => setSelectedProject(p.id)}
            style={{ background: THEME.panel, border: `1px solid ${THEME.border}`, borderRadius: 10, padding: 18, cursor: "pointer" }}
            onMouseEnter={(e) => (e.currentTarget.style.borderColor = THEME.gold)}
            onMouseLeave={(e) => (e.currentTarget.style.borderColor = THEME.border)}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
              <span style={{ color: THEME.text, fontWeight: 700, fontSize: 15 }}>{p.name}</span>
              <Badge text={p.status === "actif" ? "Actif" : "Clôturé"} bg={p.status === "actif" ? THEME.emeraldDim : THEME.surface} color={p.status === "actif" ? THEME.emerald : THEME.textMuted} />
            </div>
            {p.description && <div style={{ color: THEME.textMuted, fontSize: 12, marginBottom: 12 }}>{p.description}</div>}
            <div style={{ background: THEME.border, borderRadius: 6, height: 8, overflow: "hidden", marginBottom: 6 }}>
              <div style={{ background: THEME.gold, width: `${p.progress}%`, height: "100%" }} />
            </div>
            <div style={{ color: THEME.textMuted, fontSize: 11 }}>{p.progress}% — {p.done_tasks}/{p.total_tasks} tâches</div>
          </div>
        ))}
        {projects.length === 0 && <div style={{ color: THEME.textMuted }}>Aucun projet pour l'instant.</div>}
      </div>
      {showNewProject && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.7)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000 }}
          onClick={(e) => e.target === e.currentTarget && setShowNewProject(false)}>
          <div style={{ background: THEME.surface, border: `1px solid ${THEME.border}`, borderRadius: 14, padding: 28, width: 420, display: "flex", flexDirection: "column", gap: 16 }}>
            <h3 style={{ color: THEME.text, fontSize: 18, fontWeight: 700, margin: 0 }}>➕ Nouveau projet</h3>
            <input value={newName} onChange={(e) => setNewName(e.target.value)} placeholder="Nom du projet (ex: V1, Beta...)"
              style={{ background: THEME.panel, border: `1px solid ${THEME.border}`, borderRadius: 8, padding: "10px 14px", color: THEME.text, fontSize: 14, outline: "none" }} />
            <textarea value={newDesc} onChange={(e) => setNewDesc(e.target.value)} placeholder="Description (optionnel)" rows={3}
              style={{ background: THEME.panel, border: `1px solid ${THEME.border}`, borderRadius: 8, padding: "10px 14px", color: THEME.text, fontSize: 13, outline: "none", resize: "vertical", fontFamily: "inherit" }} />
            <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
              <button onClick={() => setShowNewProject(false)} style={{ background: "transparent", border: `1px solid ${THEME.border}`, color: THEME.textMuted, borderRadius: 8, padding: "9px 18px", cursor: "pointer", fontSize: 13 }}>Annuler</button>
              <button onClick={createProject} style={{ background: THEME.accentDim, border: `1px solid ${THEME.accent}`, color: THEME.accent, borderRadius: 8, padding: "9px 20px", cursor: "pointer", fontSize: 13, fontWeight: 700 }}>Créer</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
